import enTranslations from "./translations.en.json";
import arTranslations from "./translations.ar.json";
import frTranslations from "./translations.fr.json";

export type Language = "en" | "ar" | "fr";

export const translations = {
  en: enTranslations,
  ar: arTranslations,
  fr: frTranslations,
} as const;

export function getTranslation(lang: Language, key: string): string {
  const keys = key.split(".");
  let value: any = translations[lang];

  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k as keyof typeof value];
    } else {
      return key; // Return key if translation not found
    }
  }

  return typeof value === "string" ? value : key;
}

export function t(lang: Language, key: string, params?: Record<string, string>): string {
  let translation = getTranslation(lang, key);

  // Replace parameters in the format {paramName}
  if (params) {
    Object.entries(params).forEach(([param, value]) => {
      translation = translation.replace(new RegExp(`\\{${param}\\}`, "g"), value);
    });
  }

  return translation;
}

